(function($) {

    if ( ! Modernizr.objectfit ) {

      $('#collage-banner div').each(function () {
        var $container = $(this),
            imgUrl = $container.find('img').prop('src');
        if (imgUrl) {
          $container
            .css('backgroundImage', 'url(' + imgUrl + ')')
            .addClass('no-object-fit');
        }
      });

      $('#success-story .wp-block-image').each(function () {
        var $container = $(this),
            imgUrl = $container.find('img').prop('src');
        if (imgUrl) {
          $container
            .css('backgroundImage', 'url(' + imgUrl + ')')
            .addClass('no-object-fit');
        }
      });

    }

})( jQuery );
